<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    아이템 상세정보
                </div>
                <div class="member_write_wrap">
                    <div class="write_content">
                        <div class="write_box">
                            <item-write-component :item-type="`detail`" :item-key="itemKey"></item-write-component>
                            <div class="btn_box">
                                <el-button class="com_btn" @click="$router.back()">목록</el-button>
<!--                                <el-button class="com_btn" @click="writeItem()">저장</el-button>-->
<!--                                <el-button class="com_del" @click="deleteItem()">삭제</el-button>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import ItemWriteComponent from "@/components/item/ItemWriteComponent";
import EventBus from "@/utils/event-bus";
export default {
    name: "ItemDetail",
    mixins: [],
    components: {
        ItemWriteComponent
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            itemKey: this.$route.params.idx
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        writeItem(){
            EventBus.$emit('writeItem')
        },
        deleteItem(){
            EventBus.$emit('deleteItem')
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>
